import { render, staticRenderFns } from "./TextMessageDashboard.vue?vue&type=template&id=1612d40b&scoped=true&"
import script from "./TextMessageDashboard.vue?vue&type=script&lang=js&"
export * from "./TextMessageDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TextMessageDashboard.vue?vue&type=style&index=0&id=1612d40b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1612d40b",
  null
  
)

export default component.exports